import { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import Loader from '../Main/Loader'
import { Link, useNavigate } from 'react-router-dom'
import { login } from '../../Services/authService'
import { loginUser } from '../../Redux/Slice/Auth/authSlice'
import { useDispatch } from 'react-redux'
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa'

const LoginCard = () => {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const navigate = useNavigate()

    const handleEmail = (e) => { setEmail(e.target.value) }
    const handlePassword = (e) => { setPassword(e.target.value) }
    const dispatch = useDispatch();

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     let body = {
    //         email,
    //         password
    //     };

    //     setIsLoading(true);

    //     let response = await login(body);

    //     if (response.code === 200) {
    //         toast?.success(response?.message);
    //         localStorage.setItem("token", response?.result?.token);
    //         localStorage.setItem("user", JSON.stringify(response?.result?.user));
    //         setIsLoading(false);
    //         navigate("/dashboard")

    //     } else if (response.code === 401) {
    //         toast?.error(response?.errors);
    //         setIsLoading(false);
    //     } else {
    //         // optional: show other errors
    //         // for (const [key, value] of Object.entries(response?.errors)) {
    //         //     toast?.error(value);
    //         // }
    //         setIsLoading(false);
    //     }
    // };


    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true)

        const body = {
            email,
            password
        }

        try {
            const response = await dispatch(loginUser(body)).unwrap();
            if (response.code === 200) {
                // await localStorage.setItem('access_token', response?.response?.data?.accessToken);
                toast?.success(response?.message)
                setIsLoading(false)
                navigate('/dashboard');
            } else if (response.code != 200 || response.code != 201) {
                toast?.error(response?.message)
                setIsLoading(false)
            } else {
                for (const [key, value] of Object.entries(response?.errors)) {
                    toast?.error(value)
                }
                setIsLoading(false)
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log("errr in login", error)
        }
    }

    return (
        <div className="card border-0 shadow p-3 mt-3">

            <h3 className='fw-bold'>Login</h3>


            <p>Enter your credentials to login your account</p>
            <Form onSubmit={handleLogin}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control value={email} onChange={handleEmail} type="email" placeholder="Enter email" />
                </Form.Group>

                <Form.Group className="mb-3 position-relative">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        className="pr-5"
                        placeholder="Password"
                        value={password}
                        onChange={handlePassword}
                        minLength={8}
                        required
                    />
                    <div
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: 'absolute',
                            top: '38px',
                            right: '15px',
                            cursor: 'pointer',
                            zIndex: 2,
                        }}
                    >
                        {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                    </div>
                </Form.Group>

                <Form.Group className="mb-3 d-none" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control value={password} onChange={handlePassword} type="password" placeholder="Password" />
                </Form.Group>
                <Button variant="primary" className='w-100' type="submit">
                    {
                        isLoading ? <Loader /> : "Login"
                    }
                </Button>

                <div className='mt-2 text-center'>

                    <Link to={"/forgot-password"} className='text-decoration-none '>
                        Forgot Password?
                    </Link>
                </div>
            </Form>
        </div>
    )
}

export default LoginCard